var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoyous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5814 74.4505L29.3579 72.12L24.6967 76.567L26.9203 78.8976C38.3558 90.8836 56.8953 93.9848 71.8821 85.3322C86.7534 76.7462 93.3507 59.3443 88.8965 43.5454L88.0224 40.4451L81.8219 42.1932L82.6959 45.2935C86.3698 58.3245 80.919 72.6758 68.661 79.753C56.3075 86.8853 41.013 84.3361 31.5814 74.4505Z",
    fill: "#D458B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7545 7.17538C1.17008 21.9465 -7.59577 54.6611 7.17538 80.2455C21.9465 105.83 54.6611 114.596 80.2455 99.8246C105.83 85.0535 114.596 52.3388 99.8246 26.7545C85.0535 1.17008 52.3388 -7.59577 26.7545 7.17538ZM12.7545 77.0244C-0.237628 54.5213 7.4725 25.7467 29.9756 12.7545C52.4787 -0.237627 81.2533 7.4725 94.2455 29.9756C107.238 52.4787 99.5275 81.2533 77.0244 94.2455C54.5213 107.238 25.7467 99.5275 12.7545 77.0244Z",
    fill: "#D458B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoyous);
export default __webpack_public_path__ + "static/media/joyous.b9a204a26ca1b0e5e1e1dd21cf5dc9a0.svg";
export { ForwardRef as ReactComponent };